import React from "react";

import useTranslation from "/hook/useTranslation/useTranslation";

import TutorialScreenBase from "./TutorialScreenBase";

const AccountCreatedTutorial = () => {
  const { t } = useTranslation("screen-generalTutorials");

  return (
    <TutorialScreenBase title={t("accountCreated.title")} subtitle={t("accountCreated.subTitle")} />
  );
};

export default AccountCreatedTutorial;
